import React from 'react';

const Square = ({ quantity }) => {
  return (
    <>
      <div className="square"></div>
      <p className="square__text">{quantity}</p>
    </>
  );
};

export default Square;